import React, { useState } from "react"
import { Link } from "gatsby"

function PricingGrid() {

  const [state, setState] = useState({
    name: "?",
    hass_users: "1",
    hass_house_users: "1",
    coosa_users: "1",
  })


  const changeHandler = e => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  function calculatePrice(numUsers, product) {
    let price = 1800
    for (let i = 1; i <= numUsers; i++) {
      if (i >= 3 && i <= 5) {
        // if # of licenses is between 3 and 5, add $640
        price += 720
      }
      if (i >= 6 && i <= 9) {
        // if # of licenses is between 9 and 6, add $320
        price += 440
      }
      if (i >= 10) {
        // if # of licenses is greater than 10, add $220
        price += 300
      }
    }

    if (product === "hasshouse") {
      //Hass House is 50% off
      price = price * .5
    }

    return price
  }

  const number_of_users_options = [
    {
      name: "1-2",
      value: 2,
    },
    {
      name: "3",
      value: 3,
    },
    {
      name: "4",
      value: 4,
    },
    {
      name: "5",
      value: 5,
    },
    {
      name: "6",
      value: 6,
    },
    {
      name: "7",
      value: 7,
    },
    {
      name: "8",
      value: 8,
    },
    {
      name: "9",
      value: 9,
    },
    {
      name: "10",
      value: 10,
    },
    {
      name: "11",
      value: 11,
    },
    {
      name: "12",
      value: 12,
    },
    {
      name: "13",
      value: 13,
    },
    {
      name: "14",
      value: 14,
    },
    {
      name: "15",
      value: 15,
    },
    {
      name: "16",
      value: 16,
    },
    {
      name: "17",
      value: 17,
    },
    {
      name: "18",
      value: 18,
    },
    {
      name: "19",
      value: 19,
    },
    {
      name: "20",
      value: 20,
    },
  ]


  return (
    <section className="pricing-area">
      <div className="container">

        <div className="row">
          {/* Single pricing table */}
          <div className="col-lg-4 col-md-6">
            <div className="single-pricing-table left-align">
              <div className="pricing-header">
                <h3>HASS House</h3>
              </div>

              <div className="number-of-users pricing-headers">
                <span>Number of Users: </span>
                <select
                  id="numUsers2"
                  name="hass_house_users"
                  onChange={changeHandler}
                  value={state.hass_house_users}
                >
                  {number_of_users_options.map(item => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="price">
                <sup>$</sup>
                {calculatePrice(state.hass_house_users, "hasshouse")}{" "}
                <sub> first year</sub>
                <br />
                <sup>$</sup>
                {calculatePrice(state.hass_house_users, "hasshouse") / 2}{" "}
                <sub> 2nd+ years*</sub>
              </div>

              <ul className="pricing-features">
                <li>
                  <i className="bx bxs-badge-check"></i>
                  NFPA 13, 13D, 13R hydraulic calculations
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Reduce time to design residential systems
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Simplified data entry
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Same calculation engine as HASS
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Clear and concise reporting
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Water supply graph and cover sheets
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  NETWORK calculation method per NFPA 13D
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Drill size calculator
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Easy review and approval
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Full results are plotted on a single N1.85 graph
                </li>
              </ul>

              <div className="btn-box">
                <Link
                  to="/checkout"
                  state={{ product: "hassHouse", numUsers: state.hass_house_users }}
                  className="default-btn"
                >
                  <i className="bx bxs-hot"></i>
                  Order and Download Now
                  <span></span>
                </Link>
              </div>
            </div>
          </div>

          {/* Single pricing table */}
          <div className="col-lg-4 col-md-6">
            <div className="single-pricing-table left-align primary-table">
              <div className="pricing-header">
                <h3>HASS</h3>
              </div>
              <div className="number-of-users pricing-headers">
                <span>Number of Users: </span>
                <select
                  id="numUsers"
                  name="hass_users"
                  onChange={changeHandler}
                  value={state.hass_users}
                >
                  {number_of_users_options.map(item => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="price">
                <sup>$</sup>
                {calculatePrice(state.hass_users, "hass")}{" "}
                <sub> first year</sub>
                <br />
                <sup>$</sup>
                {calculatePrice(state.hass_users, "hass") / 2}{" "}
                <sub> 2nd+ years*</sub>
              </div>

              <ul className="pricing-features">
                <li>
                  <i className="bx bxs-badge-check"></i>
                  NFPA 13, 13D, 13R, 14, 15, 20, 24, 750 and other standards
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Includes HASS House
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Grid Estimator
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Tree Generator
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  System Builder
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Darcy-Weisbach Calculations
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  User Pump
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Fixed Pressure Loss
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Static Pressure Calculator
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Flow Test Summary
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Loop Analysis
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Hydraulic Gradient
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Earthquake Bracing
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Customized Pipe Tables
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Job Costing
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Water Hammer
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Pressure Reducing Valves
                </li>
              </ul>

              <div className="btn-box">
                <Link
                  to="/checkout"
                  state={{ product: "hass", numUsers: state.hass_users }}
                  className="default-btn"
                >
                  <i className="bx bxs-hot"></i>
                  Order and Download Now
                  <span></span>
                </Link>
              </div>
            </div>
          </div>

          {/* Single pricing table */}
          <div className="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
            <div className="single-pricing-table left-align">
              <div className="pricing-header">
                <h3>COOSA</h3>
              </div>

              <div className="number-of-users pricing-headers">
                <span>Number of Users: </span>
                <select
                  id="numUsers3"
                  name="coosa_users"
                  onChange={changeHandler}
                  value={state.coosa_users}
                >
                  {number_of_users_options.map(item => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="price">
                <sup>$</sup>
                {calculatePrice(state.coosa_users, "coosa")}{" "}
                <sub> first year</sub>
                <br />
                <sup>$</sup>
                {calculatePrice(state.coosa_users, "coosa") / 2}{" "}
                <sub> 2nd+ years*</sub>
              </div>

              <ul className="pricing-features">
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Calculate systems in accordance with NFPA 12
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  For design and review of CO2 fire suppression systems
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Perfect for maritime applications
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Calculations based on two-phase flow
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Total flooding or local application
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Automatic or manual pipe sizing
                </li>
                <li>
                  <i className="bx bxs-badge-check"></i>
                  Supports balanced and unbalanced steel piping systems
                </li>

                <li>
                  <i className="bx bxs-badge-check"></i>
                  Includes COOSA-Estimator for estimating cost
                </li>
              </ul>

              <div className="btn-box">
                <Link
                  to="/checkout"
                  state={{ product: "coosa", numUsers: state.coosa_users }}
                  className="default-btn"
                >
                  <i className="bx bxs-hot"></i>
                  Order and Download Now
                  <span></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <p>* The pricing for the second year and onwards remains effective provided that the product subscription is maintained continuously.</p>
      </div>
      </section>
  )
}

export default PricingGrid
